// extracted by mini-css-extract-plugin
export default {"switchComponent":"switchField_switchComponent__4roJL","error":"switchField_error__PHDnn"};